/* The Grand Guild - home page behaviour (hero drift, comparison toggle, Brand Hub switcher,
   reviews reveal, card float, Brand Score capture popup). Loaded by gg-home-* sections. */
(function () {
  'use strict';
  if (window.GGHome) return;
  var GGHome = window.GGHome = {};
  var reduce = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var lastPageScroll = 0;
  window.addEventListener('scroll', function () { lastPageScroll = Date.now(); }, { passive: true });

  function each(root, sel, fn) {
    if (root.matches && root.matches(sel)) fn(root);
    Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
  }

  /* ---------- Hero mosaic drift ---------- */
  GGHome.drift = function (mosaic) {
    if (mosaic._ggDrift) return;
    mosaic._ggDrift = true;
    var still = reduce();
    var visible = true;
    var cols = Array.prototype.map.call(mosaic.querySelectorAll('[data-gg-col]'), function (el) {
      var track = el.querySelector('[data-gg-track]');
      var n = parseInt(el.getAttribute('data-gg-unit'), 10) || 3;
      var c = { el: el, track: track, off: 0, speed: parseFloat(el.getAttribute('data-gg-speed')) || 12,
        dir: parseFloat(el.getAttribute('data-gg-dir')) || 1, factor: still ? 0 : 1, target: still ? 0 : 1 };
      c.unit = function () { var k = track && track.children; return k && k[n] ? k[n].offsetTop - k[0].offsetTop : 0; };
      c.paint = function () { if (track) track.style.transform = 'translate3d(0,' + (-c.off).toFixed(2) + 'px,0)'; };
      c.nudge = function (dy) { var u = c.unit(); if (u <= 0) return; c.off = ((c.off + dy) % u + u) % u; c.paint(); };
      el.addEventListener('mouseenter', function () { c.target = 0; });
      el.addEventListener('mouseleave', function () { if (!still) c.target = 1; c.engaged = false; });
      el.addEventListener('focusin', function () { c.target = 0; c.engaged = true; c.enteredAt = Date.now(); });
      el.addEventListener('focusout', function () { if (!still) c.target = 1; c.engaged = false; });
      el.addEventListener('pointermove', function () { if (!c.engaged) { c.engaged = true; c.enteredAt = Date.now(); } }, { passive: true });
      el.addEventListener('wheel', function (ev) {
        if (!ev.deltaY) return;
        var now = Date.now();
        if (!c.engaged || !c.enteredAt || now - c.enteredAt < 250) return;
        if (lastPageScroll && now - lastPageScroll < 500) return;
        ev.preventDefault(); c.nudge(ev.deltaY * 0.7);
      }, { passive: false });
      el.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowDown') { ev.preventDefault(); c.nudge(60); }
        else if (ev.key === 'ArrowUp') { ev.preventDefault(); c.nudge(-60); }
      });
      return c;
    });
    if (!cols.length || still) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(mosaic);
    }
    var last = 0;
    var step = function (t) {
      if (!document.documentElement.contains(mosaic)) return;
      var dt = last ? Math.min(50, t - last) : 16; last = t;
      if (visible && !document.hidden && mosaic.offsetParent !== null) {
        cols.forEach(function (c) {
          c.factor += (c.target - c.factor) * Math.min(1, dt / 260);
          var u = c.unit(); if (u <= 0) return;
          if (c.factor > 0.002) { c.off += c.dir * c.speed * (dt / 1000) * c.factor; c.off = ((c.off % u) + u) % u; c.paint(); }
        });
      }
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  /* ---------- Generic "show more" toggles (comparison + reviews) ---------- */
  function setLabel(btn, open) {
    var lo = btn.getAttribute('data-label-open'), lc = btn.getAttribute('data-label-closed');
    var span = btn.querySelector('[data-label]');
    if (span && lo && lc) span.textContent = open ? lo : lc;
  }
  document.addEventListener('click', function (e) {
    var cmp = e.target.closest('[data-gg-home-compare-toggle]');
    if (cmp) {
      var table = document.getElementById(cmp.getAttribute('data-gg-home-compare-toggle'));
      var open = cmp.getAttribute('aria-expanded') !== 'true';
      cmp.setAttribute('aria-expanded', String(open));
      if (table) table.classList.toggle('is-all', open);
      setLabel(cmp, open);
      return;
    }
    var rev = e.target.closest('[data-gg-home-reviews]');
    if (rev) {
      var grid = document.getElementById(rev.getAttribute('aria-controls'));
      var o = rev.getAttribute('aria-expanded') !== 'true';
      rev.setAttribute('aria-expanded', String(o));
      if (grid) {
        var more = grid.querySelectorAll('[data-gg-rev-more]');
        Array.prototype.forEach.call(more, function (x) { x.hidden = !o; });
        if (o && more[0]) { var f = more[0].querySelector('figure'); if (f) { f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); } }
      }
      setLabel(rev, o);
    }
  });

  /* ---------- Brand Hub feature switcher ---------- */
  GGHome.hub = function (root) {
    if (root._ggHub) return; root._ggHub = true;
    var btns = root.querySelectorAll('[data-gg-hub-pick]');
    var shots = root.querySelectorAll('[data-gg-hub-shot]');
    var pick = function (i) {
      Array.prototype.forEach.call(btns, function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-gg-hub-pick') === i)); });
      Array.prototype.forEach.call(shots, function (s) {
        var on = s.getAttribute('data-gg-hub-shot') === i;
        s.hidden = !on;
        if (on) { var img = s.querySelector('img[loading="lazy"]'); if (img) img.loading = 'eager'; }
      });
    };
    Array.prototype.forEach.call(btns, function (b) {
      var i = b.getAttribute('data-gg-hub-pick');
      b.addEventListener('click', function () { pick(i); });
      b.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) pick(i); });
    });
  };

  /* ---------- Review card float (pointer, hover devices only) ---------- */
  GGHome.tilt = function (root) {
    if (root._ggTilt || reduce() || !window.matchMedia('(hover: hover)').matches) return;
    root._ggTilt = true;
    var MAX = 6, cur = null;
    var reset = function () { if (!cur) return; cur.style.transitionDuration = '260ms'; cur.style.transform = ''; cur.style.boxShadow = ''; cur = null; };
    root.addEventListener('pointermove', function (ev) {
      var card = ev.target.closest('[data-gg-tilt]');
      if (card !== cur) { reset(); cur = card; if (card) card.style.transitionDuration = '90ms'; }
      if (!card) return;
      var r = card.getBoundingClientRect();
      var x = Math.max(-1, Math.min(1, (ev.clientX - (r.left + r.width / 2)) / (r.width / 2))) * MAX;
      var y = Math.max(-1, Math.min(1, (ev.clientY - (r.top + r.height / 2)) / (r.height / 2))) * MAX;
      card.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0)';
      card.style.boxShadow = '0 ' + (10 + Math.abs(y)).toFixed(0) + 'px ' + (26 + Math.abs(x)).toFixed(0) + 'px -18px rgba(16,17,18,0.26)';
    }, { passive: true });
    root.addEventListener('pointerleave', reset);
  };

  /* ---------- Brand Score capture popup ---------- */
  var CAP_KEY = 'gg-capture-v1';
  GGHome.capture = function (el) {
    if (el._ggCap) return; el._ggCap = true;
    var days = parseInt(el.getAttribute('data-days'), 10) || 14;
    var delay = parseInt(el.getAttribute('data-delay'), 10) || 0;
    var form = el.querySelector('form');
    var err = el.querySelector('[data-cap-error]');
    var email = el.querySelector('[data-cap-email]');
    var consent = el.querySelector('[data-cap-consent]');
    var needConsent = el.getAttribute('data-require-consent') === 'true';
    var fired = false, timer = null, onOut = null, onScroll = null;

    var seen = function () {
      try { var t = parseInt(localStorage.getItem(CAP_KEY), 10); return !isNaN(t) && (Date.now() - t) < days * 864e5; } catch (e) { return false; }
    };
    var mark = function () { try { localStorage.setItem(CAP_KEY, String(Date.now())); } catch (e) {} };
    var disarm = function () {
      if (onOut) document.removeEventListener('mouseout', onOut);
      if (onScroll) window.removeEventListener('scroll', onScroll);
      if (timer) clearTimeout(timer);
    };
    var open = function () {
      if (!window.GG || !GG.dialog) return;
      GG.dialog.open(el);
    };
    var fire = function () {
      if (fired || document.querySelector('.gg-overlay.is-open') || document.documentElement.classList.contains('gg-lock')) return;
      fired = true; disarm(); open();
    };
    el.addEventListener('gg:dialog:close', function () { mark(); });

    var showDone = function (addr) {
      el.querySelector('[data-cap-step="form"]').hidden = true;
      el.querySelector('[data-cap-step="done"]').hidden = false;
      var p = el.querySelector('[data-cap-done-text]');
      var tpl = p.getAttribute('data-template');
      if (addr && tpl) p.textContent = tpl.replace('[email]', addr);
      var h = el.querySelector('[data-cap-done-h]'); if (h) h.focus();
    };
    var showErr = function (key) { err.textContent = el.getAttribute('data-err-' + key) || ''; err.hidden = false; };

    if (form) {
      form.addEventListener('submit', function (ev) {
        var addr = (email.value || '').trim();
        var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(addr);
        if (!okEmail || (needConsent && !consent.checked)) {
          ev.preventDefault();
          showErr(!okEmail ? 'email' : 'consent');
          (!okEmail ? email : consent).focus();
          return;
        }
        if (!window.fetch || form._ggNative) return; // native post fallback
        ev.preventDefault();
        err.hidden = true;
        var btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = true;
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
          .then(function (r) {
            if (r.redirected && /challenge/.test(r.url)) { form._ggNative = true; form.submit(); return; }
            if (!r.ok) throw new Error('post');
            mark(); showDone(addr);
          })
          .catch(function () { showErr('network'); })
          .then(function () { if (btn) btn.disabled = false; });
      });
      [email, consent].forEach(function (x) { if (x) x.addEventListener('input', function () { err.hidden = true; }); });
    }

    /* Returning from a native post: show the result straight away. */
    if (el.querySelector('[data-cap-posted]') || (err && !err.hidden && err.textContent.trim())) {
      fired = true; if (el.querySelector('[data-cap-posted]')) mark();
      setTimeout(open, 60); return;
    }
    if (/[?&#]preview=capture\b/.test(location.href)) { fired = true; setTimeout(open, 60); return; }
    if (window.Shopify && Shopify.designMode) return;
    if (seen()) return;

    if (el.getAttribute('data-exit') === 'true') {
      onOut = function (e) { if (e.clientY <= 0 && e.relatedTarget === null) fire(); };
      var lastY = window.scrollY, engaged = false;
      onScroll = function () {
        var y = window.scrollY;
        if (y > 600) engaged = true;
        if (engaged && lastY - y > 220) fire();
        lastY = y;
      };
      document.addEventListener('mouseout', onOut);
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    if (delay > 0) timer = setTimeout(fire, delay * 1000);
  };

  /* Theme editor: open the popup while its section is selected. */
  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target.querySelector('[data-gg-home-capture]');
    if (el && window.GG) GG.dialog.open(el);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var el = e.target.querySelector('[data-gg-home-capture]');
    if (el && el.classList.contains('is-open') && window.GG) GG.dialog.close(el);
  });

  GGHome.init = function (root) {
    root = root || document;
    each(root, '[data-gg-home-drift]', GGHome.drift);
    each(root, '[data-gg-home-hub]', GGHome.hub);
    each(root, '[data-gg-home-tilt]', GGHome.tilt);
    each(root, '[data-gg-home-capture]', GGHome.capture);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { GGHome.init(document); });
  else GGHome.init(document);
  document.addEventListener('shopify:section:load', function (e) { GGHome.init(e.target); });
})();
